import { Component } from '@angular/core';

@Component({
  selector: 'kbxl-customer',
  template: '<router-outlet></router-outlet>',
})
export class UserComponent {}
